import clientAxios from "../config";

/**
 * Crea una entrega de jugadas. Distribuidor only (back valida).
 * payload:
 *   { moves, method: 'document'|'qr', recipient_document?, expires_in_hours? }
 * Para method='document' devuelve la entrega ya cerrada (claimed_at poblado);
 * para method='qr' devuelve además claim_token y claim_url para el QR.
 */
const createDelivery = async (token, payload) => clientAxios.post(`/api/move-deliveries`, payload, {
    headers: { Authorization: `Bearer ${token}` },
});

/**
 * Listado paginado de entregas. Filtros admitidos: status, method,
 * recipient_document, date_from, date_to, page, per_page.
 */
const listDeliveries = async (token, params = {}) => clientAxios.get(`/api/move-deliveries`, {
    headers: { Authorization: `Bearer ${token}` },
    params,
});

/**
 * Endpoint público (sin auth) — devuelve datos básicos del QR para
 * mostrar antes de pedir login al jugador.
 */
const getDeliveryByToken = async (token) => clientAxios.get(`/api/move-deliveries/by-token/${token}`);

/**
 * Reclama un QR. Requiere auth del Jugador receptor.
 */
const claimDelivery = async (token, claimToken) => clientAxios.post(
    `/api/move-deliveries/claim/${claimToken}`,
    {},
    { headers: { Authorization: `Bearer ${token}` } }
);

/**
 * Cancela un QR pendiente y libera la reserva. Solo el distribuidor
 * dueño o un admin.
 */
const cancelDelivery = async (token, uuid) => clientAxios.delete(`/api/move-deliveries/${uuid}`, {
    headers: { Authorization: `Bearer ${token}` },
});

export {
    createDelivery,
    listDeliveries,
    getDeliveryByToken,
    claimDelivery,
    cancelDelivery,
};
